import script from "./ButtonRouteSidbar.vue?vue&type=script&setup=true&lang=ts"
export * from "./ButtonRouteSidbar.vue?vue&type=script&setup=true&lang=ts"

import "./ButtonRouteSidbar.vue?vue&type=style&index=0&id=122ca05f&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-122ca05f"]])

export default __exports__